<template>
  <div class="search">

    <el-card style="margin-bottom:12px">
      <div class="flex">
        <div class="cTitle" @click="more = !more">
          <i v-if="!more" class="el-icon-caret-right"></i>
          <i v-if="more" class="el-icon-caret-bottom"></i>
          高级筛选
        </div>
        <div class="btnAction">
          <el-input v-model="searchForm.compName" placeholder="请输入供应商名称" style="width:160px;margin-right:8px"></el-input>
          <el-button type="primary" plain @click="getDataList" size="mini">搜索</el-button>

        </div>
      </div>
      <div class="flex-container" style="margin-top: 10px;width: 440px;" v-if="more">
       <div>
        <el-input v-model="searchForm.licensePlate" placeholder="请输入车牌号" style="width:160px;margin-right:8px"></el-input>
        <el-input v-model="searchForm.goodsName" placeholder="请输入物料名称" style="width:160px;margin-right:8px"></el-input>
       </div>
       <div>

          <DatePicker type="datetimerange"
            placeholder="过毛开始日期范围"
            format="yyyy-MM-dd HH:mm:ss"
            value="yyyy-MM-dd HH:mm:ss"
            style="margin-top: 10px;width: 328px;"
            v-model="guoMaoArray"
            separator=" 至 "
            @on-change="guoMaoTimeChange"
            ></DatePicker>

            <DatePicker type="datetimerange"
            placeholder="过皮开始日期范围"
            format="yyyy-MM-dd HH:mm:ss"
            value="yyyy-MM-dd HH:mm:ss"
            v-model="guoPiArray"
            separator=" 至 "
            style="margin-top: 10px;width: 328px;"
            @on-change="guoPiTimeChange"
            ></DatePicker>

       </div>

      </div>
    </el-card>

    <el-card>
      <div class="flex">
        <div class="cTitle">
          <el-tag type="danger" style="margin-right:8px">异常</el-tag>
          异常过磅记录
        </div>
        <div class="btnAction">
          <el-button type="primary" @click="exportDataClick('select')" icon="el-icon-c-scale-to-original">导出已选</el-button>
        </div>
      </div>
      <div style="margin-top:16px">

        <vxe-table align="center" ref="table" :export-config="{
          types: ['csv'],
          isHeader: true,
        }" :print-config="{}" stripe size="medium" :height="height - 147 - 50 - 95" :loading="loading"
          :column-config="{ resizable: true }" :row-config="{ isHover: true }" :data="data">

          <vxe-column fixed="left" type="checkbox" width="40"></vxe-column>

          <vxe-column width="120" field="compName" title="供应商名称">
            <template #default="{ row }">
              <span>{{ row.compName }}</span>
            </template>
          </vxe-column>

          <vxe-column width="120" field="goodItems" title="物料名称">
            <template #default="{ row }">
              <span>{{ row.goodsName }}</span>
            </template>
          </vxe-column>

          <vxe-column width="120" field="licensePlate" title="车牌号">
            <template #default="{ row }">
              <span>{{ row.licensePlate }}</span>
            </template>
          </vxe-column>

          <vxe-column width="90" field="plateColor" title="车牌颜色">
            <template #default="{ row }">
              <span>{{ row.plateColor }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="driverName" title="司机姓名">
            <template #default="{ row }">
              <span>{{ row.driverName }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="driverMobile" title="司机手机号">
            <template #default="{ row }">
              <span>{{ row.driverMobile }}</span>
            </template>
          </vxe-column>
          <vxe-column width="130" field="orderStatus" title="订单状态">
            <template #default="{ row }">
              <el-tag v-if="row.orderStatus == 0">司机已扫码</el-tag>
              <el-tag v-if="row.orderStatus == 1">一次过磅完成</el-tag>
              <el-tag v-if="row.orderStatus == 2" type="success">订单完成</el-tag>
            </template>
          </vxe-column>
          <vxe-column width="100" field="recordStatus" title="记录状态">
            <template #default="{ row }">
              <el-tag type="danger">异常</el-tag>
            </template>
          </vxe-column>
          <vxe-column width="120" field="plateColor" title="过毛时间">
            <template #default="{ row }">
              <span>{{ row.grossTime }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="plateColor" title="过皮时间">
            <template #default="{ row }">
              <span>{{ row.tareTime }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="plateColor" title="验收人确认">
            <template #default="{ row }">
              <span>{{ row.checkOperateName }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="plateColor" title="卸货人确认">
            <template #default="{ row }">
              <span>{{ row.unLoadOperateName }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="grossWeight" title="毛重">
            <template #default="{ row }">
              <span>{{ row.grossWeight }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="tareWeight" title="皮重">
            <template #default="{ row }">
              <span>{{ row.tareWeight }}</span>
            </template>
          </vxe-column>
          <vxe-column width="120" field="netWeight" title="净重">
            <template #default="{ row }">
              <span>{{ row.netWeight }}</span>
            </template>
          </vxe-column>

          <vxe-column fixed="right" title="操作" width="120">
            <template #default="{ row }">
              <el-button size="small" type="primary" icon="el-icon-document" @click="showDetail(row)">查看详情</el-button>
            </template>
          </vxe-column>

        </vxe-table>
        <Row type="flex" justify="end" class="page">
          <Page
            :current="page.currentPage"
            :total="page.total"
            :page-size="page.pageSize"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
            :page-size-opts="[10, 20, 50]"
            size="small"
            show-total
            show-elevator
            show-sizer
          ></Page>
        </Row>

      </div>

      <div>
        <el-image-viewer :on-close="closeImgViewer" v-if="dialogPics" :mask-closable="false" :initial-index="initialIndex" :url-list="imgList" />
      </div>
    </el-card>

    <!-- 自定义导出数据 -->
    <Modal v-model="exportModalVisible" :title="exportTitle" :loading="loadingExport" @on-ok="exportCustomData">
      <Form ref="exportForm" :label-width="100">
        <FormItem label="导出文件名">
          <Input v-model="filename" />
        </FormItem>
        <FormItem label="自定义导出列">
          <CheckboxGroup v-model="chooseColumns">
            <Checkbox v-for="(item, i) in exportColumns" :label="item.title" :key="i" :value="item.checked"
              :disabled="item.disabled"></Checkbox>
          </CheckboxGroup>
        </FormItem>
      </Form>
    </Modal>

    <!-- 详情抽屉 -->
    <Drawer v-model="detailModalVisible" title="异常过磅记录详情" width="1200" :closable="true">
      <div v-if="detailLoading" style="padding:80px;text-align:center">
        <Spin size="large">
          <Icon type="ios-loading" size="40" class="spin-icon-load"></Icon>
          <div style="margin-top:10px;color:#999">加载中...</div>
        </Spin>
      </div>
      <div v-else-if="currentRecord" style="padding:20px">
        <el-tabs v-model="activeTab" type="border-card">

          <!-- 基本信息 Tab -->
          <el-tab-pane label="基本信息" name="basic">
            <!-- 供应商信息 -->
            <el-card shadow="never" style="margin-bottom:15px">
              <div slot="header" class="info-card-header">
                <i class="el-icon-office-building"></i> 供应商信息
              </div>
              <Row :gutter="20">
                <Col span="8">
                  <div class="info-item">
                    <span class="info-label">供应商名称</span>
                    <span class="info-value">{{ currentRecord.compName || '-' }}</span>
                  </div>
                </Col>
                <Col span="8">
                  <div class="info-item">
                    <span class="info-label">物料名称</span>
                    <span class="info-value">{{ currentRecord.goodItems || currentRecord.goodsName || '-' }}</span>
                  </div>
                </Col>
                <Col span="8">
                  <div class="info-item">
                    <span class="info-label">规格型号</span>
                    <span class="info-value">{{ currentRecord.goodsModel || '-' }}</span>
                  </div>
                </Col>
              </Row>
              <Row :gutter="20" style="margin-top:20px">
                <Col span="8">
                  <div class="info-item">
                    <span class="info-label">收货单位</span>
                    <span class="info-value">{{ currentRecord.receiptCompany || '-' }}</span>
                  </div>
                </Col>
                <Col span="8">
                  <div class="info-item">
                    <span class="info-label">发货单位</span>
                    <span class="info-value">{{ currentRecord.shippingCompany || '-' }}</span>
                  </div>
                </Col>
                <Col span="8">
                  <div class="info-item">
                    <span class="info-label">运输单位</span>
                    <span class="info-value">{{ currentRecord.transportCompany || '-' }}</span>
                  </div>
                </Col>
              </Row>
            </el-card>

            <!-- 车辆信息 -->
            <el-card shadow="never" style="margin-bottom:15px">
              <div slot="header" class="info-card-header">
                <i class="el-icon-truck"></i> 车辆信息
              </div>
              <Row :gutter="20">
                <Col span="6">
                  <div class="info-item">
                    <span class="info-label">车牌号</span>
                    <span class="info-value highlight-text">{{ currentRecord.licensePlate || '-' }}</span>
                  </div>
                </Col>
                <Col span="6">
                  <div class="info-item">
                    <span class="info-label">车牌颜色</span>
                    <span class="info-value">{{ currentRecord.plateColor || '-' }}</span>
                  </div>
                </Col>
                <Col span="6">
                  <div class="info-item">
                    <span class="info-label">司机姓名</span>
                    <span class="info-value">{{ currentRecord.driverName || '-' }}</span>
                  </div>
                </Col>
                <Col span="6">
                  <div class="info-item">
                    <span class="info-label">司机手机</span>
                    <span class="info-value">{{ currentRecord.driverMobile || '-' }}</span>
                  </div>
                </Col>
              </Row>
            </el-card>

            <!-- 称重数据 -->
            <el-card shadow="never" style="margin-bottom:15px">
              <div slot="header" class="info-card-header">
                <i class="el-icon-s-data"></i> 称重数据
              </div>
              <Row :gutter="20">
                <Col span="6">
                  <div class="weight-item">
                    <div class="weight-label">毛重</div>
                    <div class="weight-value gross-weight">
                      {{ currentRecord.grossWeight || '-' }}
                      <span class="weight-unit">kg</span>
                    </div>
                    <div class="weight-time">{{ currentRecord.grossTime || '-' }}</div>
                    <div class="weight-type">
                      <el-tag size="mini" type="info">
                        {{ currentRecord.grossWeightOperateType === 1 ? '自动' : '人工' }}
                      </el-tag>
                    </div>
                  </div>
                </Col>
                <Col span="6">
                  <div class="weight-item">
                    <div class="weight-label">皮重</div>
                    <div class="weight-value tare-weight">
                      {{ currentRecord.tareWeight || '-' }}
                      <span class="weight-unit">kg</span>
                    </div>
                    <div class="weight-time">{{ currentRecord.tareTime || '-' }}</div>
                    <div class="weight-type">
                      <el-tag size="mini" type="info">
                        {{ currentRecord.tareWeightOperateType === 1 ? '自动' : '人工' }}
                      </el-tag>
                    </div>
                  </div>
                </Col>
                <Col span="6">
                  <div class="weight-item">
                    <div class="weight-label">净重</div>
                    <div class="weight-value net-weight">
                      {{ currentRecord.netWeight || '-' }}
                      <span class="weight-unit">kg</span>
                    </div>
                    <div class="weight-time" style="visibility:hidden">占位</div>
                    <div class="weight-type">
                      <el-tag v-if="currentRecord.tareType === 2" size="mini" type="success">系统皮重</el-tag>
                      <el-tag v-else-if="currentRecord.tareType === 3" size="mini" type="warning">车牌皮重</el-tag>
                    </div>
                  </div>
                </Col>
                <Col span="6">
                  <!-- 预留位置 -->
                </Col>
              </Row>
            </el-card>

            <Divider orientation="left">过磅照片</Divider>
            <Row :gutter="16" style="margin-bottom:15px">
              <Col span="24" style="margin-bottom:12px">
                <div style="font-weight:bold;color:#67C23A;margin-bottom:8px">
                  <i class="el-icon-picture-outline"></i> 过毛照片
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.grossCaptureHead">
                <div class="photo-item">
                  <div class="photo-label">车头相机</div>
                  <img :src="currentRecord.grossCaptureHead"
                       @click="previewImage(currentRecord.grossCaptureHead)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.grossCaptureTail">
                <div class="photo-item">
                  <div class="photo-label">车尾相机</div>
                  <img :src="currentRecord.grossCaptureTail"
                       @click="previewImage(currentRecord.grossCaptureTail)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.grossCaptureWare">
                <div class="photo-item">
                  <div class="photo-label">车仓相机</div>
                  <img :src="currentRecord.grossCaptureWare"
                       @click="previewImage(currentRecord.grossCaptureWare)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.grossLicenseName">
                <div class="photo-item">
                  <div class="photo-label">车辆照片</div>
                  <img :src="currentRecord.grossLicenseName"
                       @click="previewImage(currentRecord.grossLicenseName)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.grossPlateName">
                <div class="photo-item">
                  <div class="photo-label">车牌照片</div>
                  <img :src="currentRecord.grossPlateName"
                       @click="previewImage(currentRecord.grossPlateName)"
                       class="photo-preview" />
                </div>
              </Col>
            </Row>

            <Row :gutter="16">
              <Col span="24" style="margin-bottom:12px">
                <div style="font-weight:bold;color:#E6A23C;margin-bottom:8px">
                  <i class="el-icon-picture-outline"></i> 过皮照片
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.tareCaptureHead">
                <div class="photo-item">
                  <div class="photo-label">车头相机</div>
                  <img :src="currentRecord.tareCaptureHead"
                       @click="previewImage(currentRecord.tareCaptureHead)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.tareCaptureTail">
                <div class="photo-item">
                  <div class="photo-label">车尾相机</div>
                  <img :src="currentRecord.tareCaptureTail"
                       @click="previewImage(currentRecord.tareCaptureTail)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.tareCaptureWare">
                <div class="photo-item">
                  <div class="photo-label">车仓相机</div>
                  <img :src="currentRecord.tareCaptureWare"
                       @click="previewImage(currentRecord.tareCaptureWare)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.tareLicenseName">
                <div class="photo-item">
                  <div class="photo-label">车辆照片</div>
                  <img :src="currentRecord.tareLicenseName"
                       @click="previewImage(currentRecord.tareLicenseName)"
                       class="photo-preview" />
                </div>
              </Col>
              <Col span="6" v-if="currentRecord.tarePlateName">
                <div class="photo-item">
                  <div class="photo-label">车牌照片</div>
                  <img :src="currentRecord.tarePlateName"
                       @click="previewImage(currentRecord.tarePlateName)"
                       class="photo-preview" />
                </div>
              </Col>
            </Row>

          </el-tab-pane>

          <!-- 车辆进出记录 Tab -->
          <el-tab-pane name="access">
            <span slot="label">
              <i class="el-icon-truck"></i> 车辆进出记录
              <el-badge v-if="currentRecord.accessRecords && currentRecord.accessRecords.length > 0"
                        :value="currentRecord.accessRecords.length"
                        type="primary" style="margin-left:5px"></el-badge>
            </span>
            <div v-if="currentRecord.accessRecords && currentRecord.accessRecords.length > 0">
              <el-card v-for="(access, index) in currentRecord.accessRecords" :key="index"
                       shadow="hover" style="margin-bottom:15px">
                <div slot="header" class="card-header">
                  <span style="font-weight:bold">
                    <i class="el-icon-position"></i> 记录 {{index + 1}}
                  </span>
                  <el-tag :type="access.accessType === 1 ? 'success' : 'warning'" size="medium">
                    {{ access.accessType === 1 ? '进厂' : '出厂' }}
                  </el-tag>
                </div>
                <Row :gutter="16">
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车牌号：</span>
                      <span class="card-value">{{ access.plateNumber || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车牌颜色：</span>
                      <span class="card-value">{{ access.plateColor || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车辆类型：</span>
                      <span class="card-value">{{ access.vehicleType || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车辆颜色：</span>
                      <span class="card-value">{{ access.vehicleColor || '-' }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px">
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">进入时间：</span>
                      <span class="card-value">{{ access.accessTime || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">出去时间：</span>
                      <span class="card-value">{{ access.outTime || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">道口名称：</span>
                      <span class="card-value">{{ access.gateName || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车道编号：</span>
                      <span class="card-value">{{ access.laneNumber || '-' }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px" v-if="access.cameraId || access.confidence">
                  <Col span="12">
                    <div class="card-item">
                      <span class="card-label">摄像头ID：</span>
                      <span class="card-value">{{ access.cameraId || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="card-item">
                      <span class="card-label">识别置信度：</span>
                      <span class="card-value">{{ access.confidence ? (access.confidence * 100).toFixed(1) + '%' : '-' }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px" v-if="access.plateImage || access.plateOutImage || access.vehicleImage || access.vehicleOutImage">
                  <Col span="24" style="margin-bottom:8px">
                    <span class="card-label">抓拍照片：</span>
                  </Col>
                  <Col span="6" v-if="access.plateImage">
                    <div class="photo-item">
                      <div class="photo-label">入场车牌</div>
                      <img :src="access.plateImage"
                           @click="previewImage(access.plateImage)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                  <Col span="6" v-if="access.vehicleImage">
                    <div class="photo-item">
                      <div class="photo-label">入场整车</div>
                      <img :src="access.vehicleImage"
                           @click="previewImage(access.vehicleImage)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                  <Col span="6" v-if="access.plateOutImage">
                    <div class="photo-item">
                      <div class="photo-label">出厂车牌</div>
                      <img :src="access.plateOutImage"
                           @click="previewImage(access.plateOutImage)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                  <Col span="6" v-if="access.vehicleOutImage">
                    <div class="photo-item">
                      <div class="photo-label">出厂整车</div>
                      <img :src="access.vehicleOutImage"
                           @click="previewImage(access.vehicleOutImage)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                </Row>
              </el-card>
            </div>
            <el-empty v-else description="暂无车辆进出记录" :image-size="120"></el-empty>
          </el-tab-pane>

          <!-- 料场记录 Tab -->
          <el-tab-pane name="point">
            <span slot="label">
              <i class="el-icon-location"></i> 料场记录
              <el-badge v-if="currentRecord.pointRecords && currentRecord.pointRecords.length > 0"
                        :value="currentRecord.pointRecords.length"
                        type="warning" style="margin-left:5px"></el-badge>
            </span>
            <div v-if="currentRecord.pointRecords && currentRecord.pointRecords.length > 0">
              <el-card v-for="(point, index) in currentRecord.pointRecords" :key="index"
                       shadow="hover" style="margin-bottom:15px">
                <div slot="header" class="card-header">
                  <span style="font-weight:bold">
                    <i class="el-icon-location-information"></i> 记录 {{index + 1}}
                  </span>
                  <el-tag v-if="point.unloadStatus === 0" type="info" size="medium">待卸货</el-tag>
                  <el-tag v-else-if="point.unloadStatus === 1" type="warning" size="medium">卸货中</el-tag>
                  <el-tag v-else-if="point.unloadStatus === 2" type="success" size="medium">已完成</el-tag>
                </div>
                <Row :gutter="16">
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车牌号：</span>
                      <span class="card-value">{{ point.plateNumber || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车牌颜色：</span>
                      <span class="card-value">{{ point.plateColor || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">车辆类型：</span>
                      <span class="card-value">{{ point.vehicleType || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">记录状态：</span>
                      <span class="card-value">
                        <el-tag v-if="point.recordStatus === '卸货中'" type="warning" size="mini">{{ point.recordStatus }}</el-tag>
                        <el-tag v-else-if="point.recordStatus === '待出场'" type="info" size="mini">{{ point.recordStatus }}</el-tag>
                        <el-tag v-else-if="point.recordStatus === '已完成'" type="success" size="mini">{{ point.recordStatus }}</el-tag>
                        <el-tag v-else-if="point.recordStatus === '异常'" type="danger" size="mini">{{ point.recordStatus }}</el-tag>
                        <span v-else>-</span>
                      </span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px">
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">司机姓名：</span>
                      <span class="card-value">{{ point.driverName || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">司机电话：</span>
                      <span class="card-value">{{ point.driverPhone || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">司机身份证：</span>
                      <span class="card-value">{{ point.driverIdCard || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">通道编号：</span>
                      <span class="card-value">{{ point.laneNumber || '-' }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px">
                  <Col span="8">
                    <div class="card-item">
                      <span class="card-label">所属公司：</span>
                      <span class="card-value">{{ point.companyName || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="8">
                    <div class="card-item">
                      <span class="card-label">公司编码：</span>
                      <span class="card-value">{{ point.companyCode || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="8">
                    <div class="card-item">
                      <span class="card-label">出入口方向：</span>
                      <span class="card-value">{{ point.gateDirection || '-' }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px">
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">实际到达时间：</span>
                      <span class="card-value">{{ point.actualArrivalTime || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">实际离开时间：</span>
                      <span class="card-value">{{ point.actualDepartureTime || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">进出时间：</span>
                      <span class="card-value">{{ point.accessTime || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="6">
                    <div class="card-item">
                      <span class="card-label">进出类型：</span>
                      <span class="card-value">{{ point.accessType || '-' }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px">
                  <Col span="12">
                    <div class="card-item">
                      <span class="card-label">内部备注：</span>
                      <span class="card-value">{{ point.internalRemark || '-' }}</span>
                    </div>
                  </Col>
                  <Col span="12">
                    <div class="card-item">
                      <span class="card-label">司机备注：</span>
                      <span class="card-value">{{ point.driverRemark || '-' }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px" v-if="point.exceptionReason">
                  <Col span="24">
                    <div class="card-item">
                      <span class="card-label">异常原因：</span>
                      <span class="card-value" style="color:#F56C6C">{{ point.exceptionReason }}</span>
                    </div>
                  </Col>
                </Row>
                <Row :gutter="16" style="margin-top:12px" v-if="point.inPhotoUrl || point.outPhotoUrl || point.inGoodsUrl || point.outGoodsUrl">
                  <Col span="24" style="margin-bottom:8px">
                    <span class="card-label">现场照片：</span>
                  </Col>
                  <Col span="6" v-if="point.inPhotoUrl">
                    <div class="photo-item">
                      <div class="photo-label">入场照片</div>
                      <img :src="point.inPhotoUrl"
                           @click="previewImage(point.inPhotoUrl)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                  <Col span="6" v-if="point.inGoodsUrl">
                    <div class="photo-item">
                      <div class="photo-label">入场抓拍</div>
                      <img :src="point.inGoodsUrl"
                           @click="previewImage(point.inGoodsUrl)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                  <Col span="6" v-if="point.outPhotoUrl">
                    <div class="photo-item">
                      <div class="photo-label">出场照片</div>
                      <img :src="point.outPhotoUrl"
                           @click="previewImage(point.outPhotoUrl)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                  <Col span="6" v-if="point.outGoodsUrl">
                    <div class="photo-item">
                      <div class="photo-label">出场抓拍</div>
                      <img :src="point.outGoodsUrl"
                           @click="previewImage(point.outGoodsUrl)"
                           class="photo-preview-small" />
                    </div>
                  </Col>
                </Row>
              </el-card>
            </div>
            <el-empty v-else description="暂无料场记录" :image-size="120"></el-empty>
          </el-tab-pane>

        </el-tabs>
      </div>
    </Drawer>

  </div>
</template>

<script>
// 根据你的实际请求api.js位置路径修改
import { getRecordAByCondition } from "@/api/index";
import excel from "@/libs/excel";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { exportColumn } from "../queryList/exportColumn";

export default {
  name: "abnormalRecordList",
  components: {
    ElImageViewer
  },
  data() {
    return {
      guoMaoArray:[],
      guoPiArray:[],
      initialIndex:0,
      exportData: [],
      exportModalVisible: false,
      exportColumns: exportColumn,
      chooseColumns: [],
      filename: "异常过磅信息数据",
      exportTitle: "确认导出",
      exportType: "",
      loadingExport: true,

      dialogPics: false,
      imgList: [],

      detailModalVisible: false,
      detailLoading: false,
      currentRecord: null,
      activeTab: 'basic', // 详情弹窗默认tab

      more: false,
      selectItem: {},
      height: 600,
      tableSize: "default",
      openTip: true, // 显示提示
      loading: true, // 表单加载状态
      searchForm: { // 搜索框初始化对象
        userType: 1,
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "createTime", // 默认排序字段
        order: "desc", // 默认排序方式
        recordStatus: 1, // 只查询异常记录（recordStatus = 1）
      },
      selectList: [], // 多选数据
      data: [], // 表单数据
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20 // 每页显示多少条
      },

    };
  },
  methods: {
    guoPiTimeChange(t){
      if (t[0] == ''){
        this.searchForm.guoPiSearchStartTime = null
        this.searchForm.guoPiSearchEndTime = null
      } else {
        this.searchForm.guoPiSearchStartTime = t[0]
        this.searchForm.guoPiSearchEndTime = t[1]
      }
    },
    guoMaoTimeChange(t){
      if (t[0] == ''){
        this.searchForm.guoMaoSearchStartTime = null
        this.searchForm.guoMaoSearchEndTime = null
      } else {
        this.searchForm.guoMaoSearchStartTime = t[0]
        this.searchForm.guoMaoSearchEndTime = t[1]
      }
    },
    exportDataClick(t) {
      if (t == 'select') {
        let selectRecords = this.$refs.table.getCheckboxRecords()
        if(selectRecords == 0){
          this.$notify.warning({
            message:"请至少选一个"
          })
          return;
        }
        this.exportData = selectRecords;
        this.exportType = "part";
        this.exportModalVisible = true;
        this.exportTitle =
          "确认导出 " + this.exportData.length + " 条数据";
      }
    },
    exportCustomData() {
      if (this.filename == "") {
        this.filename = "异常过磅数据";
      }
      // 判断勾选导出列
      let exportColumns = [];
      this.exportColumns.forEach((e) => {
        this.chooseColumns.forEach((c) => {
          if (e.title == c && !e.disabled) {
            exportColumns.push(e);
          }
        });
      });
      this.exportModalVisible = false;
      let title = [];
      let key = [];
      exportColumns.forEach((e) => {
        title.push(e.title);
        key.push(e.key);
      });
      const params = {
        title: title,
        key: key,
        data: this.exportData,
        autoWidth: true,
        filename: this.filename,
      };
      excel.export_array_to_excel(params);
    },

    preImg(v,row) {
      v = v.replace('http://183.129.176.30:8081/','https://www.zmxxkj.net.cn/')
       let ar = [v]
      this.initialIndex = 0
      this.imgList = ar
      this.dialogPics = true
    },
    closeImgViewer() {
      this.dialogPics = false;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'auto';
      document.removeEventListener("touchmove", m, true);
    },
    init() {
      this.getDataList();
      let array = [];
      this.exportColumns.forEach((e) => {
        array.push(e.title);
      });
      this.chooseColumns = array;
    },
    changePage(v) {
      this.page.currentPage = v;
      this.getDataList();
    },
    changePageSize(v) {
      this.page.pageSize = v;
      this.page.currentPage = 1; // 重置到第一页
      this.getDataList();
    },
    getDataList() {
      this.loading = true;

      getRecordAByCondition(Object.assign({
        current: this.page.currentPage,
        size: this.page.pageSize
      }, this.searchForm)).then(res => {
        this.loading = false;
        if (res.success) {
          // 后端已筛选，直接使用
          this.data = res.result.records;
          this.page.total = res.result.total;
        }
      });
    },
    // 显示详情
    async showDetail(row) {
      this.detailLoading = true;
      this.detailModalVisible = true;
      try {
        const res = await this.getRequest("/record/getDetailById?id=" + row.id);
        if (res.success) {
          this.currentRecord = res.result;
        } else {
          this.$Message.error(res.message || "获取详情失败");
          this.detailModalVisible = false;
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$Message.error("获取详情失败");
        this.detailModalVisible = false;
      } finally {
        this.detailLoading = false;
      }
    },
    // 预览图片
    previewImage(imageUrl) {
      if (imageUrl) {
        this.imgList = [imageUrl];
        this.initialIndex = 0;
        this.dialogPics = true;
      }
    },
  },
  mounted() {
    this.init();

    this.height = (window.innerHeight)
    window.onresize = () => {
      return (() => {
        this.height = (window.innerHeight)
      })()
    }
  }
};
</script>
<style lang="less">
@import "@/styles/table-common.less";

.flex {
  display: flex;
}

.cTitle {
  cursor: pointer;
  color: black;
  font-size: 16px;
  font-weight: 800;
}

.btnAction {
  flex: 1;
  text-align: right;
}

.vxe-pager.is--perfect .vxe-pager--num-btn:not(.is--disabled).is--active {
  background-color: #b6986d;
}

.is--checked.vxe-checkbox,
.is--checked.vxe-checkbox .vxe-checkbox--icon,
.is--checked.vxe-custom--option,
.is--checked.vxe-custom--option .vxe-checkbox--icon,
.is--checked.vxe-export--panel-column-option,
.is--checked.vxe-export--panel-column-option .vxe-checkbox--icon,
.is--checked.vxe-table--filter-option,
.is--checked.vxe-table--filter-option .vxe-checkbox--icon,
.is--indeterminate.vxe-checkbox,
.is--indeterminate.vxe-checkbox .vxe-checkbox--icon,
.is--indeterminate.vxe-custom--option,
.is--indeterminate.vxe-custom--option .vxe-checkbox--icon,
.is--indeterminate.vxe-export--panel-column-option,
.is--indeterminate.vxe-export--panel-column-option .vxe-checkbox--icon,
.is--indeterminate.vxe-table--filter-option,
.is--indeterminate.vxe-table--filter-option .vxe-checkbox--icon,
.vxe-table--render-default .is--checked.vxe-cell--checkbox,
.vxe-table--render-default .is--checked.vxe-cell--checkbox .vxe-checkbox--icon,
.vxe-table--render-default .is--indeterminate.vxe-cell--checkbox,
.vxe-table--render-default .is--indeterminate.vxe-cell--checkbox .vxe-checkbox--icon {
  color: #b6986d
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
}

.flex-item {
  width: 50%; /* 每个项目宽度为容器宽度的一半 */
  padding: 10px;
  box-sizing: border-box;
}

.detail-item {
  margin-bottom: 12px;
}

.detail-label {
  font-weight: bold;
  color: #606266;
  margin-right: 8px;
}

.detail-value {
  color: #303133;
}

/* 详情弹窗样式优化 */
.el-tabs--border-card {
  box-shadow: none;
  border: 1px solid #e4e7ed;
}

.el-tabs--border-card>.el-tabs__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  transition: all .3s;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  background-color: #fff;
  border-bottom-color: #fff;
  font-weight: bold;
}

.el-divider--horizontal {
  margin: 20px 0;
}

.el-divider__text {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
}

/* Badge 样式 */
.el-badge__content.is-fixed {
  top: 8px;
  right: 10px;
}

/* Empty 样式 */
.el-empty {
  padding: 40px 0;
}

.el-empty__description {
  margin-top: 16px;
  color: #909399;
  font-size: 14px;
}

/* 照片展示样式 */
.photo-item {
  text-align: center;
  margin-bottom: 15px;
}

.photo-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
}

.photo-preview {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
  transition: all .3s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.photo-preview:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.photo-preview-small {
  width: 100%;
  height: 120px;
  object-fit: cover;
  border-radius: 6px;
  cursor: pointer;
  transition: all .3s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

.photo-preview-small:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(0,0,0,0.2);
}

/* 卡片布局样式 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-item {
  margin-bottom: 8px;
  line-height: 1.8;
}

.card-label {
  font-weight: 500;
  color: #606266;
  margin-right: 8px;
}

.card-value {
  color: #303133;
}

/* 基本信息样式 */
.info-card-header {
  font-weight: bold;
  font-size: 15px;
  color: #303133;
}

.info-item {
  display: flex;
  flex-direction: column;
  line-height: 1.6;
}

.info-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}

.info-value {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.highlight-text {
  color: #409EFF;
  font-weight: bold;
  font-size: 16px;
}

/* 称重数据卡片样式 */
.weight-item {
  text-align: center;
  padding: 15px 10px;
  background: #f5f7fa;
  border-radius: 8px;
  transition: all .3s;
}

.weight-item:hover {
  background: #ecf5ff;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(64,158,255,0.15);
}

.weight-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.weight-value {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.weight-unit {
  font-size: 14px;
  font-weight: normal;
  margin-left: 3px;
  color: #909399;
}

.gross-weight {
  color: #67C23A;
}

.tare-weight {
  color: #E6A23C;
}

.net-weight {
  color: #F56C6C;
}

.weight-time {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
  min-height: 20px;
}

.weight-type {
  margin-top: 5px;
}
</style>

